import Vue from 'vue';
import {
  CodeToText
} from "element-china-area-data";
//千分符过滤器
Vue.filter('formatPrice', function (value = 0, currencyType = '') {
  if (value && value != 0) {
    var result = (value.toString()).indexOf(".");
    if (result != -1) {
      var value = Number(value).toFixed(2);
      var intPart = parseInt(Number(value)); //获取整数部分
      var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); //将整数部分逢三一断
      var value2Array = value.split(".");
      if (value2Array.length == 2) {
        let floatPart = value2Array[1].toString(); //拿到小数部分
        return intPartFormat + "." + floatPart;
      }
    } else {
      let res;
      res = (value || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
      return currencyType + res;
    }
  } else {
    return 0;
  }
});

//日期格式过滤器
Vue.filter('timeFilter', function (value) {
  var res = value.toString();
  var year, month, day;
  year = res.substring(0, 4);
  month = res.substring(4, 6);
  day = res.substring(6, 8);
  var data = year + '-' + month + '-' + day;
  return data;
});

//日期格式过滤器2
Vue.filter('timeFilter2', function (value) {
  var res = value.toString();
  var year, month, day;
  month = res.substring(5, 7);
  day = res.substring(8, 10);
  var data = month + '/' + day;
  return data;
});

//时间戳过滤器
Vue.filter('Timestamp', function (value) {
  // var date = new Date(value);
  // return date.toLocaleString().split(' ')[0];
  if (value != null && value != "") {
    let unixtime = value.replace(/-/g, "/").replace("T", " ").split(".")[0].split(":");
    return unixtime[0] + ":" + unixtime[1];
  } else {
    return null;
  }

});


//日期格式过滤器
Vue.filter('dateFormat', function (value) {
  var date = value.toString();
  if (date.length == 8) {
    return date.slice(0, 4) + '/' + date.slice(4, 6) + '/' + date.slice(6, 8);
  }
});
//转化为%
Vue.filter('Percentage', function (value) {
  return value / 5 + "%"
});

//时间过滤器
Vue.filter('timeFormat', function (value) {
  var theTime = parseInt(value); // 秒
  var theTime1 = 0; // 分
  var theTime2 = 0; // 小时

  if (theTime > 60) {
    theTime1 = parseInt(theTime / 60);
    theTime = parseInt(theTime % 60);

    if (theTime1 > 60) {
      theTime2 = parseInt(theTime1 / 60);
      theTime1 = parseInt(theTime1 % 60);
    }
  }


  var result = parseInt(theTime);
  if (theTime1 > 0) {
    result = parseInt(theTime1) + ":" + result;
  }
  if (theTime2 > 0) {
    result = parseInt(theTime2) + ":" + result;
  } else {
    result = '00' + ":" + result;
  }
  return result;
})

//解地区code码
Vue.filter('addressCode', function (value) {
  if (value == "暂无") {
    return "暂无"
  } else {
    return CodeToText[value]
  }
});
//转换时间戳
Vue.filter("currentime", function (value) {
  if (value == 0) {
    return "--"
  } else {
    var oDate = new Date(value),
      oYear = oDate.getFullYear(),
      oMonth = oDate.getMonth() + 1,
      oDay = oDate.getDate(),
      oHour = oDate.getHours(),
      oMin = oDate.getMinutes(),
      oSen = oDate.getSeconds();
    if (oMonth < 10) {
      oMonth = "0" + oMonth;
    }
    if (oDay < 10) {
      oDay = "0" + oDay;
    }
    if (oHour < 10) {
      oHour = "0" + oHour;
    }
    if (oMin < 10) {
      oMin = "0" + oMin
    }
    if (oSen < 10) {
      oSen = "0" + oSen
    }
    var oTime = oYear + '-' + oMonth + '-' + oDay + "   " + oHour + ":" + oMin+":"+oSen; //最后拼接时间
    return oTime
  }
})



// WEBPACK FOOTER //
// ./src/api/filter.js